import { Components, Theme } from '@mui/material';

import { FONT_FAMILY } from '../consts';

export function getMuiCssBaseline(theme: Theme): Components['MuiCssBaseline'] {
  return {
    styleOverrides: {
      html: {
        scrollBehavior: 'smooth',
      },
      body: {
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        boxSizing: 'border-box',
        fontFamily: FONT_FAMILY,
        fontSize: 16,
        flexDirection: 'column',
        flex: 1,
        margin: 0,
        padding: 0,
        position: 'relative',
        scrollBehavior: 'smooth',
        textRendering: 'optimizeLegibility',
        backgroundColor: theme.palette.background.paper,
      },
      a: {
        color: 'inherit',
        fontSize: 'inherit',
        textDecoration: 'none',
        '&:hover': {
          color: 'inherit',
        },
      },
      'button, input, optgroup, select, textarea': {
        fontFamily: 'inherit',
        fontSize: '100%',
        lineHeight: 1.1,
        margin: 0,
      },
      '::-moz-focus-inner': { borderStyle: 'none', padding: 0 },
    },
  };
}
